export default __webpack_public_path__ + "static/colaneri-26aa355d165597bfac58677d3f4ac1f6.jpg";